import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'
import animateScrollTo from 'animated-scroll-to'
import Heading from 'grommet/components/Heading'
import { Helmet } from 'react-helmet'
import routesList from '../../resources/routes'
import './Sitemap.css'

class Sitemap extends Component {
  handleWaypointEnter = () => {
    const { setParticleVisibility } = this.props
    setParticleVisibility('home', 'sectionOneParticlesVisible', false)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', true)
  }

  componentDidMount() {
    animateScrollTo(0, { speed: 800 })
  }
  render() {
    return (
      <div className="Sitemap">
        <Helmet>
          <title>Copper Coast Technologies - Sitemap</title>
          <meta name="description" content="Copper Coast Technologies - Web Design Agency. Browse through our sitemap to visit some of our most popular pages." />
        </Helmet>
        <Waypoint scrollableAncestor={window} onEnter={this.handleWaypointEnter}/>
        <div className="Sitemap-container">
          <Heading strong className="Sitemap-heading" tag="h2">Sitemap</Heading>
          { routesList.map((route, i) => {
            return (<Link key={`Sitemap-${i}`} to={`/${route.path}`} className="Sitemap-link"><span>{route.title}</span></Link>)
          })}
        </div>
      </div>
    )
  }
}

export default withRouter(Sitemap)


// WEBPACK FOOTER //
// ./src/components/Sitemap/index.js